// A reel's title is human text — what the gallery tile and the share page put
// above the video. The file it arrived in only ever supplies the first guess.

// Only these come off a suggested title. A blanket "drop the last dotted tail"
// would eat the ".5" of "Boda v2.5", and the guess is offered for editing, so
// being conservative costs nothing and being wrong costs a wrong name.
const VIDEO_EXTENSIONS = [
  'mp4', 'mov', 'm4v', 'webm', 'mkv', 'avi', 'mpg', 'mpeg', 'ogv', '3gp',
]

const EXTENSION_RE = new RegExp(`\\.(?:${VIDEO_EXTENSIONS.join('|')})$`, 'i')

/**
 * The title to suggest for a reel uploaded as this file: its name with the
 * video extension off.
 *
 * The suggestion is what an operator who just picks a file and clicks upload
 * ends up publishing, so it has to be presentable on its own — "Highlights",
 * not "Highlights.mp4". Every consumer then renders the stored title verbatim.
 *
 * @param {?string} fileName The uploaded file's name.
 * @returns {string} The suggested title, or '' when there is no name.
 */
export function titleFromFileName(fileName) {
  const name = (fileName || '').trim()
  if (!name) return ''
  return name.replace(EXTENSION_RE, '').trim() || name
}
